import request from 'hb-redux-store/util/request';

export const getNotificationsApi = () => request.get('/api/getNotifications');

export const postMarkAsReadNotificationsApi = data =>
  request.post('/api/markReadNotifications', data);
